import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import './RelatedPosts.css'
import BlogCard from '../BlogCard/BlogCard'

const RelatedPosts = ({ page, relatedPosts }) => {
    return (
        <section className="blog-grid-section position-relative py-5">
            <div className="bg-overlay-related-post"></div>
            <Container>
                <h1 className="text-white fw-bold mb-5">Related Articles</h1>
                <Row>
                    {relatedPosts.map((post, index) => (
                        <Col md={4} sm={6} className="mb-4" key={index}>
                            <BlogCard {...post} />
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    )
}

export default RelatedPosts